import * as React from "react"
import { cn } from "../../lib/utils"
import { useTheme } from "../../contexts/ThemeContext"

const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => {
    const { colors } = useTheme()

    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-2xl border px-4 py-2.5 text-sm transition-[border-color,background-color,box-shadow] duration-200 ease-out placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none",
          className
        )}
        style={{
          backgroundColor: colors.surfaceAlt || colors.surface,
          borderColor: `${colors.border}CC`,
          color: colors.text,
          boxShadow: `inset 0 1px 0 ${colors.shadow}08`,
        }}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea } 
